import { Component, OnInit } from '@angular/core';
import { finalize, forkJoin } from 'rxjs';
import { ComplianceAdminService } from '../../../_core/_services/_compliance/compliance-admin.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-admin-compliance-dashboard',
  standalone: false,
  templateUrl: './admin-compliance-dashboard.html',
  styleUrl: './admin-compliance-dashboard.css',
})
export class AdminComplianceDashboard implements OnInit {
  loading = false;
  error: string | null = null;

  counts = {
    jurisdictions: 0,
    tiers: 0,
    policies: 0,
    submittedApplications: 0,
    underReviewApplications: 0,
    approvedApplications: 0,
    rejectedApplications: 0
  };

  recentApplications: any[] = [];

  riskCounts = {
    openFlags: 0,
    resolvedFlags: 0,
    highRiskOpenFlags: 0,
    flaggedUsers: 0
  };

  recentFlags: any[] = [];

  constructor(
    private adminService: ComplianceAdminService,
    private notifyService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;

    forkJoin({
      jurisdictions: this.adminService.getJurisdictions({ page: 1, pageSize: 500 }),
      tiers: this.adminService.getTiers({ page: 1, pageSize: 500 }),
      policies: this.adminService.getPolicies({ page: 1, pageSize: 500 }),
      submitted: this.adminService.getReviews({ status: 'Submitted', page: 1, pageSize: 20 }),
      underReview: this.adminService.getReviews({ status: 'UnderReview', page: 1, pageSize: 20 }),
      approved: this.adminService.getReviews({ status: 'Approved', page: 1, pageSize: 20 }),
      rejected: this.adminService.getReviews({ status: 'Rejected', page: 1, pageSize: 20 }),
      recent: this.adminService.getReviews({ page: 1, pageSize: 10 }),
      riskDashboard: this.adminService.getFlagDashboard()
    })
    .pipe(finalize(() => (this.loading = false)))
    .subscribe({
      next: (res: any) => {
        const jurisdictions = res?.jurisdictions?.data || res?.jurisdictions || [];
        const tiers = res?.tiers?.data || res?.tiers || [];
        const policies = res?.policies?.data || res?.policies || [];
        const submitted = res?.submitted?.data || res?.submitted || [];
        const underReview = res?.underReview?.data || res?.underReview || [];
        const approved = res?.approved?.data || res?.approved || [];
        const rejected = res?.rejected?.data || res?.rejected || [];
        const recent = res?.recent?.data || res?.recent || [];
        const riskDashboard = res?.riskDashboard?.data || res?.riskDashboard || {};

        this.counts = {
          jurisdictions: jurisdictions.length,
          tiers: tiers.length,
          policies: policies.length,
          submittedApplications: submitted.length,
          underReviewApplications: underReview.length,
          approvedApplications: approved.length,
          rejectedApplications: rejected.length
        };

        this.riskCounts = {
          openFlags: riskDashboard?.openFlagsCount || 0,
          resolvedFlags: riskDashboard?.resolvedFlagsCount || 0,
          highRiskOpenFlags: riskDashboard?.highRiskOpenFlagsCount || 0,
          flaggedUsers: riskDashboard?.distinctFlaggedUsersCount || 0
        };

        this.recentApplications = recent;
        this.recentFlags = riskDashboard?.recentOpenFlags || [];
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to load compliance dashboard.';
      }
    });
  }

  getStatusClass(status?: string): string {
    switch (status) {
      case 'Approved': return 'text-bg-success';
      case 'Rejected': return 'text-bg-danger';
      case 'Submitted':
      case 'UnderReview': return 'text-bg-warning';
      default: return 'text-bg-secondary';
    }
  }

  getRiskClass(riskLevel?: number): string {
    if (!riskLevel) return 'text-bg-secondary';
    if (riskLevel >= 80) return 'text-bg-danger';
    if (riskLevel >= 60) return 'text-bg-warning';
    if (riskLevel >= 40) return 'text-bg-info';
    return 'text-bg-secondary';
  }
}